module.exports = __webpack_public_path__ + "media/components/country-flag/static/bh-c91e398c3125fea19aca7464211cdd74.svg";